module.exports = __webpack_public_path__ + "img/ie.ff79777.png";